/*import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

    constructor(public router: Router) { }
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //In ascolto alle chiamate per settare il token
        let access_token = localStorage.getItem('access_token_einvoice');
        let newRequest =request;
        if(access_token){
            newRequest = request.clone({
                headers : request.headers.append( 'einvauth' , access_token!=undefined ? access_token : '').append('X-Frontend-User', 'angular-client')
            });
        } else {
            this.router.navigate(['/Login']);
        }
        return next.handle(newRequest);
    }
    
}*/

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

    constructor(private router: Router) { }
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const access_token = localStorage.getItem('access_token_einvoice');

        let newRequest = request;
        if (access_token) {
            newRequest = request.clone({
                setHeaders: {
                    'einvauth': access_token,
                    'X-Frontend-User': 'angular-client'
                }
            });
        }

        return next.handle(newRequest).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    // Token scaduto o non valido, reindirizza alla login
                    localStorage.removeItem('access_token_einvoice');
                    this.router.navigate(['/Login']);
                } else if (error.status === 401) {
                    console.log("Errore 403");
                }
                return throwError(error); // RxJS 6 compatibile
            })
        );
    }
}
